import rules from '../data/indemnite-grand-rouleur.json';
import rejectionReasons from '../data/rejectionReasons';

const { metadata, results, calculation } = rules;
const threshold = calculation.rfr_per_part.threshold;

export function getQuestionById(id) {
  return rules.questions.find((q) => q.id === id) ?? null;
}

export function getFirstQuestionId() {
  return rules.questions[0]?.id ?? null;
}

export function getOrderedQuestionIds() {
  return rules.questions.map((q) => q.id);
}

/**
 * Évalue la règle de ressources : RFR / parts <= seuil
 */
export function evaluateResources(rfr, parts) {
  const rfrNum = Number(rfr);
  const partsNum = Number(parts);

  if (!Number.isFinite(rfrNum) || !Number.isFinite(partsNum) || partsNum <= 0) {
    return {
      eligible: false,
      reason: 'Veuillez indiquer un RFR et un nombre de parts valides.',
      rfrPerPart: null,
    };
  }

  const rfrPerPart = rfrNum / partsNum;
  const eligible = rfrPerPart <= threshold;

  return {
    eligible,
    reason: eligible ? null : rejectionReasons.ressources,
    rfrPerPart,
    threshold,
  };
}

export function buildEligibleResult(rfrPerPart) {
  return {
    status: results.eligible.status,
    amount: results.eligible.amount,
    currency: results.eligible.currency,
    message: results.eligible.message,
    reason: null,
    rfrPerPart,
    threshold,
  };
}

export function buildIneligibleResult(reason, extras = {}) {
  return {
    status: results.ineligible.status,
    amount: results.ineligible.amount,
    currency: results.ineligible.currency,
    message: results.ineligible.message,
    reason,
    threshold,
    ...extras,
  };
}

export function getRejectionReason(questionId) {
  return rejectionReasons[questionId] ?? results.ineligible.message;
}

export { rules, metadata, threshold };